import React, { useEffect, useState } from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { colors, typography, spacing, borderRadius } from '../styles/theme';

const CONFETTI_COLORS = ['#f94144', '#f3722c', '#f8961e', '#f9c74f', '#90be6d'];
const CONFETTI_COUNT = 50;

const generateConfetti = () => {
  return Array.from({ length: CONFETTI_COUNT }).map((_, i) => ({
    id: i,
    color: CONFETTI_COLORS[Math.floor(Math.random() * CONFETTI_COLORS.length)],
    left: `${Math.random() * 100}%`,
    size: Math.random() * (8 - 4) + 4,
    delay: Math.random() * 2,
    collected: false,
    startingTop: -20,
    finalPosition: window.innerHeight - (Math.random() * 50) // Random stack height at bottom
  }));
};

export const ThankYouPopup = ({ onClose }) => {
  const [confetti, setConfetti] = useState(generateConfetti());
  const [collectedCount, setCollectedCount] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 5000);

    return () => clearTimeout(timer);
  }, [onClose]);

  useEffect(() => {
    const handleConfettiAnimation = () => {
      setConfetti(prev => prev.map(piece => {
        if (piece.collected) return piece;
        return {
          ...piece,
          collected: Math.random() < 0.05 // 5% chance to collect each update
        };
      }));
    };

    const interval = setInterval(handleConfettiAnimation, 100);
    return () => clearInterval(interval);
  }, []);

  return (
    <View style={styles.container}>
      <View style={styles.overlay}>
        <View style={styles.content}>
          <Text style={styles.title}>Thank You!</Text>
          <Text style={styles.message}>Your report has been submitted successfully.</Text>
          <TouchableOpacity onPress={onClose} style={styles.button}>
            <Text style={styles.buttonText}>Close</Text>
          </TouchableOpacity>
        </View>
        <View style={styles.confettiContainer}>
          {confetti.map(piece => (
            <View
              key={piece.id}
              style={[
                styles.confettiPiece,
                {
                  backgroundColor: piece.color,
                  left: piece.left,
                  width: piece.size,
                  height: piece.size,
                  top: piece.collected ? undefined : piece.startingTop,
                  bottom: piece.collected ? 0 : undefined,
                  transition: 'all 2s ease-in-out',
                  transform: piece.collected 
                    ? 'translateY(0) rotate(0deg)' 
                    : `translateY(${piece.finalPosition}px) rotate(720deg)`,
                  transitionDelay: `${piece.delay}s`
                }
              ]}
            />
          ))}
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
  },
  overlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    overflow: 'hidden',
  },
  content: {
    backgroundColor: colors.backgroundSecondary,
    padding: spacing.xl,
    borderRadius: borderRadius.lg,
    alignItems: 'center',
    maxWidth: 400,
    width: '90%',
    zIndex: 2,
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  },
  title: {
    fontFamily: typography.primaryFont,
    fontSize: 28,
    color: colors.textPrimary,
    marginBottom: spacing.md,
    textAlign: 'center',
  },
  message: {
    fontFamily: typography.primaryFont,
    fontSize: 16,
    color: colors.textSecondary,
    marginBottom: spacing.xl,
    textAlign: 'center',
    lineHeight: 24,
  },
  button: {
    backgroundColor: colors.primary,
    paddingVertical: spacing.md,
    paddingHorizontal: spacing.xl,
    borderRadius: borderRadius.md,
    minWidth: 120,
  },
  buttonText: {
    fontFamily: typography.primaryFont,
    fontSize: 16,
    color: colors.textPrimary,
    textAlign: 'center',
  },
  confettiContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    pointerEvents: 'none',
  },
  confettiPiece: {
    position: 'absolute',
    borderRadius: '50%',
  }
});

export default ThankYouPopup; 